import { render, staticRenderFns } from "./AccountSummaryDetail.vue?vue&type=template&id=636ef3dd&scoped=true&"
import script from "./AccountSummaryDetail.vue?vue&type=script&lang=js&"
export * from "./AccountSummaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./AccountSummaryDetail.vue?vue&type=style&index=0&id=636ef3dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636ef3dd",
  null
  
)

export default component.exports